import React from 'react';
import styles from './UnableToSubmit.module.scss';
import { Button } from 'drift-ui';
import UnableToSubmit from '../../../assets/images/unable_to_submit.svg';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const UnableToSubmitComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <img src={UnableToSubmit} alt="Expired Icon" className={styles.expiredIcon} width={235} height={235} />
      <h1 className={styles.title}>{t('unable_to_submit')}</h1>
      <p className={styles.subText}>{t('unable_to_submit_description')}</p>
      <div className={styles.footer}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch({ type: 'SET_SUBMISSION_STATUS', submissionStatus: 'submitting' });
          }}
          className={styles.tryAgainButton}
        >
          {t('try_again')}
        </Button>
      </div>
    </div>
  );
};

export default UnableToSubmitComponent;
